(function () {
  'use strict';

  var modal = null;
  var selectedVariantId = null;
  var MAX_PILLS = 6;
  var scrollLockY = 0;
  var lastOpenAt = 0;
  var unlockTimer = null;
  var openTrigger = null;

  function scrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }

  function lockScroll() {
    scrollLockY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
    var sb = scrollbarWidth();
    if (sb > 0) {
      document.body.style.paddingRight = sb + 'px';
    }
    document.documentElement.classList.add('ss-qv-open');
    document.body.classList.add('ss-qv-open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    if (unlockTimer) {
      clearTimeout(unlockTimer);
      unlockTimer = null;
    }
    var y = scrollLockY || 0;
    document.documentElement.classList.remove('ss-qv-open');
    document.body.classList.remove('ss-qv-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    document.documentElement.style.scrollBehavior = 'auto';
    document.documentElement.scrollTop = y;
    document.body.scrollTop = y;
    window.scrollTo(0, y);
    requestAnimationFrame(function () {
      window.scrollTo(0, y);
      document.documentElement.style.scrollBehavior = '';
    });
    if (openTrigger && typeof openTrigger.focus === 'function') {
      try { openTrigger.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
    }
  }

  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'ss-qv';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Quick view');
    modal.innerHTML =
      '<div class="ss-qv__panel">' +
        '<div class="ss-qv__head">' +
          '<div class="ss-qv__head-left">' +
            '<p class="ss-qv__head-label">Quick select</p>' +
            '<h2 data-qv-title>Product</h2>' +
          '</div>' +
          '<button type="button" class="ss-qv__close" data-qv-close aria-label="Close quick view">' +
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="ss-qv__body" data-qv-body><div class="ss-qv__loading">Loading…</div></div>' +
      '</div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
    modal.querySelector('[data-qv-close]').addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
    modal.addEventListener('touchmove', function (e) {
      var body = modal.querySelector('[data-qv-body]');
      if (!body) return;
      if (!body.contains(e.target)) e.preventDefault();
    }, { passive: false });
    return modal;
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.add('is-closing');
    modal.classList.remove('is-open');
    modal.style.removeProperty('pointer-events');
    unlockScroll();
    unlockTimer = setTimeout(function () {
      modal.classList.remove('is-closing');
      modal.style.removeProperty('pointer-events');
      document.dispatchEvent(new CustomEvent('ss:qv-close'));
      var body = modal.querySelector('[data-qv-body]');
      if (body) body.innerHTML = '<div class="ss-qv__loading">Loading…</div>';
    }, 280);
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return '£' + (cents / 100).toFixed(2);
  }

  function getOptionName(opt, idx) {
    if (typeof opt === 'string') return opt;
    if (opt && opt.name) return opt.name;
    return 'Option ' + (idx + 1);
  }

  function getOptionValues(product, optIdx) {
    var opt = product.options[optIdx];
    if (opt && opt.values && opt.values.length) return opt.values;
    var values = [];
    product.variants.forEach(function (v) {
      var val = v['option' + (optIdx + 1)];
      if (val && values.indexOf(val) === -1) values.push(val);
    });
    return values;
  }

  function findVariant(product, selections) {
    return product.variants.find(function (v) {
      return v.option1 === selections[0] &&
        (selections.length < 2 || v.option2 === selections[1]) &&
        (selections.length < 3 || v.option3 === selections[2]);
    });
  }

  function stripHtml(html) {
    var d = document.createElement('div');
    d.innerHTML = html || '';
    return (d.textContent || d.innerText || '').trim();
  }

  function renderProduct(product) {
    var body = modal.querySelector('[data-qv-body]');
    var titleEl = modal.querySelector('[data-qv-title]');
    if (titleEl) titleEl.textContent = product.title;

    var variant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    selectedVariantId = variant ? variant.id : null;

    var selections = [];
    for (var i = 0; i < (product.options || []).length; i++) {
      selections.push(variant ? variant['option' + (i + 1)] : null);
    }

    var imgHtml = product.featured_image
      ? '<img src="' + product.featured_image + '" alt="" width="600" height="600" loading="lazy">'
      : '<div class="ss-qv__ph" aria-hidden="true">' +
          '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>' +
        '</div>';

    var priceHtml = variant
      ? (variant.compare_at_price > variant.price
          ? formatMoney(variant.price) + ' <s>' + formatMoney(variant.compare_at_price) + '</s>'
          : formatMoney(variant.price))
      : '';

    var desc = stripHtml(product.description || '').slice(0, 140);
    if ((product.description || '').length > 140) desc += '…';

    var optsHtml = '';
    (product.options || []).forEach(function (opt, optIdx) {
      var optName = getOptionName(opt, optIdx);
      var values = getOptionValues(product, optIdx);
      var shown = values.slice(0, MAX_PILLS);
      var hidden = values.length - shown.length;
      optsHtml += '<div class="ss-qv__opts" data-opt-idx="' + optIdx + '">' +
        '<label>' + optName + '</label><div class="ss-qv__pills">';
      shown.forEach(function (val) {
        var active = selections[optIdx] === val ? ' is-active' : '';
        optsHtml += '<button type="button" class="ss-qv__pill' + active + '" data-opt-val="' + String(val).replace(/"/g, '&quot;') + '">' + val + '</button>';
      });
      optsHtml += '</div>';
      if (hidden > 0) {
        optsHtml += '<p class="ss-qv__more-hint">+' + hidden + ' more on the full product page</p>';
      }
      optsHtml += '</div>';
    });

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var productUrl = root + 'products/' + product.handle;

    /* Render info column wrapped in .ss-qv__info */
    body.innerHTML =
      '<div class="ss-qv__grid">' +
        '<div class="ss-qv__media" data-qv-media>' + imgHtml + '</div>' +
        '<div class="ss-qv__info">' +
          (product.vendor ? '<p class="ss-qv__vendor">' + product.vendor + '</p>' : '') +
          '<h3 class="ss-qv__title">' + product.title + '</h3>' +
          '<div class="ss-qv__price" data-qv-price>' + priceHtml + '</div>' +
          (desc ? '<p class="ss-qv__desc">' + desc + '</p>' : '') +
          '<div class="ss-qv__opts-wrap">' + optsHtml + '</div>' +
          '<a href="' + productUrl + '" class="ss-qv__full-link">' +
            'View full details' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 5l7 7-7 7"/></svg>' +
          '</a>' +
          '<div class="ss-qv__actions">' +
            '<button type="button" class="ss-qv__add" data-qv-add ' + (variant && !variant.available ? 'disabled' : '') + '>' +
              (variant && !variant.available ? 'Sold out' : 'Add to cart') +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>';

    body.querySelectorAll('.ss-qv__pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var group = pill.closest('.ss-qv__opts');
        if (!group || pill.classList.contains('is-unavailable')) return;
        group.querySelectorAll('.ss-qv__pill').forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        var idx = parseInt(group.getAttribute('data-opt-idx'), 10);
        selections[idx] = pill.getAttribute('data-opt-val');
        var next = findVariant(product, selections);
        if (!next) return;
        selectedVariantId = next.id;
        var priceEl = body.querySelector('[data-qv-price]');
        if (priceEl) {
          priceEl.innerHTML = next.compare_at_price > next.price
            ? formatMoney(next.price) + ' <s>' + formatMoney(next.compare_at_price) + '</s>'
            : formatMoney(next.price);
        }
        var addBtn = body.querySelector('[data-qv-add]');
        if (addBtn) {
          addBtn.disabled = !next.available;
          addBtn.textContent = next.available ? 'Add to cart' : 'Sold out';
        }
      });
    });

    var addBtn = body.querySelector('[data-qv-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (!selectedVariantId || addBtn.disabled) return;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
        var formData = new FormData();
        formData.append('id', selectedVariantId);
        formData.append('quantity', 1);
        formData.append('sections', 'cart-drawer,cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);
        fetch((root) + 'cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: formData
        })
          .then(function (r) { return r.json(); })
          .then(function (response) {
            if (response.status) throw new Error(response.description || 'Add failed');
            document.dispatchEvent(new CustomEvent('ss:cart-added', { detail: response }));
            closeModal();
          })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to cart';
          });
      });
    }
  }

  function openQuickView(handle) {
    if (!handle) return;
    var now = Date.now();
    if (now - lastOpenAt < 350) return;
    lastOpenAt = now;

    ensureModal();
    if (unlockTimer) {
      clearTimeout(unlockTimer);
      unlockTimer = null;
    }
    modal.classList.remove('is-closing');
    modal.classList.add('is-open');
    modal.style.pointerEvents = 'auto';
    lockScroll();
    document.dispatchEvent(new CustomEvent('ss:qv-open'));
    var body = modal.querySelector('[data-qv-body]');
    body.innerHTML = '<div class="ss-qv__loading">Loading…</div>';

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(renderProduct)
      .catch(function () {
        body.innerHTML = '<div class="ss-qv__loading">Could not load product.</div>';
      });
  }

  function handleOpenTrigger(e) {
    var btn = e.target.closest('[data-ss-quick-view]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    openTrigger = btn;
    var handle = btn.getAttribute('data-ss-quick-view');
    if (handle) openQuickView(handle);
  }

  document.addEventListener('click', handleOpenTrigger, true);
  window.ssOpenQuickView = openQuickView;
})();
